import React from 'react';
import styled from 'styled-components';
import Surface from '../components/Surface';
import { Heading, Body, Label, Accent } from '../components/Typography';

const PageWrapper = styled(Surface).attrs({ tone: 'base' })`
  padding: 4rem 2rem;

  @media (max-width: 768px) {
    padding: 2.5rem 1.5rem;
  }
`;

const Inner = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const PageLabel = styled(Label)`
  display: block;
  color: #a0412d;
  margin-bottom: 0.75rem;
`;

const PageTitle = styled(Heading)`
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 800;
  margin-bottom: 2.5rem;
`;

const ContentBlock = styled(Surface).attrs({ tone: 'raised' })`
  padding: 2rem;
  border-radius: 1.25rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 20px 40px rgba(56, 49, 45, 0.05);
`;

const BlockLabel = styled(Label)`
  display: block;
  color: #a0412d;
  margin-bottom: 0.6rem;
`;

const BlockBody = styled(Body)`
  line-height: 1.8;
`;

const About = () => (
  <PageWrapper>
    <Inner>
      <PageLabel>The Story</PageLabel>
      <PageTitle>About <Accent>Sari.</Accent></PageTitle>

      <ContentBlock>
        <BlockLabel>How it started</BlockLabel>
        <BlockBody>
          Sari's acting journey began as part of a nationwide talent search, which led her to become
          the face of Genesis Energy — one of New Zealand's largest energy providers. With her vibrant
          personality and natural presence, she quickly became a recognisable figure across television,
          radio, and billboards throughout the country.
        </BlockBody>
      </ContentBlock>

      <ContentBlock>
        <BlockLabel>On stage and screen</BlockLabel>
        <BlockBody>
          Throughout the years, Sari has continued to develop her craft through theatrical
          productions, acting for camera classes, and vocal training. Her dedication goes
          beyond the screen — she works continuously to expand her range across performance,
          singing, and physical disciplines.
        </BlockBody>
      </ContentBlock>

      <ContentBlock>
        <BlockLabel>Representation</BlockLabel>
        <BlockBody>
          Sari is represented by <strong>LBF Actors</strong> — one of New Zealand's leading
          talent agencies. All professional enquiries should be directed to her agent,
          Liz, at <a href="mailto:liz@lbfactors.nz" style={{ color: '#a0412d' }}>liz@lbfactors.nz</a> or 09 215 8296.
        </BlockBody>
      </ContentBlock>
    </Inner>
  </PageWrapper>
);

export default About;
